import {
  InvoiceReportDetailFormInputAdditionalValue,
  InvoiceReportDetailFormInputsResponse,
  InvoiceReportDetailFormInputsResponseInputAdditionalValues,
} from 'ap-openapi';
import { useCallback } from 'react';

const excludeFormType = [
  'ApReportFormInputInvoicePayeeType',
  'ApReportFormInputInvoicePayeeSelect',
  'ApReportFormInputInvoiceInstantPayee',
  'ApReportFormInputInvoiceBookDateField',
  'ApReportFormInputInvoiceDueDateField',
  'ApReportFormInputSpecialExceptionStatus',
];

// Filtered is_hidden=true
export const filteredIsHiddenReportFormInputs = (
  reportFormInputTypeInfo: InvoiceReportDetailFormInputsResponse[]
) => {
  // It should show the report_form if the item has a value even if the report_form has is_hidden=true
  const filteredAllReportFormInput = reportFormInputTypeInfo
    .filter(({ is_hidden, input_values }) => {
      // 値がある場合は input_values が空でないのでその判定を行う
      const hasInputValues = (input_values?.length || 0) > 0;
      return hasInputValues || !is_hidden;
    })
    // ここでfilterされたデータは全て表示するので is_hidden を false にして表示する
    .map((item) => ({ ...item, is_hidden: false }));
  return filteredAllReportFormInput;
};

export const useConvertApiDataToReportForm = () => {
  return useCallback(
    (reportFormInputs: InvoiceReportDetailFormInputsResponse[]) => {
      return reportFormInputs.filter(
        (item) => !excludeFormType.includes(item.type)
      );
    },
    []
  );
};

export const convertInputAdditionalValues = (
  value: InvoiceReportDetailFormInputsResponseInputAdditionalValues | undefined
): InvoiceReportDetailFormInputAdditionalValue[] => {
  return Array.isArray(value)
    ? value
    : typeof value === 'undefined'
    ? []
    : [value];
};

export const inputAdditionalValuesToInputAdditionalValue = (
  value:
    | InvoiceReportDetailFormInputsResponseInputAdditionalValues
    | null
    | undefined
): InvoiceReportDetailFormInputAdditionalValue | undefined => {
  return Array.isArray(value)
    ? value[0]
    : value === undefined || value === null
    ? undefined
    : value;
};
